<template>
  <div>
    <a
      href="#"
      class="btn btn-primary float-right half-gutter-bottom"
      v-on:click.prevent="openAddModal"
      >Add Credit Hire Organisation</a
    >
    <table class="table table-bordered">
      <thead>
        <tr>
          <th width="30%">Name</th>
          <th>Modules</th>
          <th width="25%"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-bind:key="key"
          v-for="(credit_hire_organisation, key) in credit_hire_organisations"
        >
          <td>{{ credit_hire_organisation.name }}</td>
          <td>
            <span
              v-bind:key="index"
              v-for="(module, index) in credit_hire_organisation.modules"
              class="label label-primary half-gutter-right"
              v-text="module.label"
            ></span>
          </td>
          <td>
            <button
              class="btn btn-warning"
              v-on:click.prevent="openEditModal(key)"
            >
              Edit
            </button>
            <button
              class="btn btn-danger"
              v-on:click.prevent="removeCreditHireOrganisation(key)"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal
      :show="modals.add"
      :large="true"
      v-on:close="closeAddModal"
      :fire-event="false"
    >
      <div slot="title">
        <h4>Add Credit Hire Organisation</h4>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="form-horizontal">
            <selectlist
              :options="available_credit_hire_organisations"
              label="Credit Hire Organisation"
              name="credit_hire_organisation"
              placeholder="Please Select"
              :required="true"
              label-name="name"
              key-name="identifier"
              v-model="add.credit_hire_organisation"
              :show-error="add.errors.has('credit_hire_organisation')"
              :error-message="add.errors.get('credit_hire_organisation')"
            ></selectlist>
            <div class="form-group">
              <label for="modules" class="control-label col-md-2"
                >Modules</label
              >
              <div class="col-md-10">
                <multiselect
                  :options="modules"
                  :multiple="true"
                  label="label"
                  key="identifier"
                  v-on:input="updateAddModules"
                ></multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="closeAddModal"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          v-on:click.prevent="addCreditHireOrganisation"
        >
          Add Credit Hire Organisation
        </button>
      </div>
    </modal>

    <modal
      :show="modals.edit"
      :large="true"
      v-on:close="closeEditModal"
      :fire-event="false"
    >
      <div slot="title">
        <h4>
          Edit Credit Hire Organisation: <span>{{ edit.name }}</span>
        </h4>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="form-horizontal">
            <div class="form-group">
              <label for="modules" class="control-label col-md-2"
                >Modules</label
              >
              <div class="col-md-10">
                <multiselect
                  :options="modules"
                  :multiple="true"
                  label="label"
                  key="identifier"
                  :value="edit.modules"
                  track-by="identifier"
                  v-on:input="updateEditModules"
                ></multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="closeEditModal"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          v-on:click.prevent="updateCreditHireOrganisation"
        >
          Update Credit Hire Organisation
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      credit_hire_organisations: [],
      available_credit_hire_organisations: [],
      modals: {
        add: false,
        edit: false
      },
      add: new window.Form({
        credit_hire_organisation: null,
        modules: []
      }),
      edit: new window.Form({
        credit_hire_organisation: null,
        modules: []
      }),
      editingIndex: null,
      modules: []
    };
  },

  mounted() {
    this.getAllCreditHireOrganisations();
    this.getModules();
  },

  methods: {
    updateAddModules(data) {
      this.add.modules = [];

      data.forEach(item => {
        this.add.modules.push(item.identifier);
      });
    },

    updateEditModules(data) {
      this.edit.modules = [];

      data.forEach(item => {
        this.edit.modules.push(item);
      });
    },

    getModules() {
      window.Ajax.get('/modules')
        .then(response => {
          this.modules = response.data;
        })
        .catch(error => {});
    },

    removeCreditHireOrganisation(key) {
      window
        .swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete the association!'
        })
        .then(() => {
          let credit_hire_organisation = this.credit_hire_organisations[key];

          window.Ajax.delete(
            `/agents/${this.$route.params.identifier}/credit-hire-organisations/${credit_hire_organisation.identifier}`
          )
            .then(response => {
              window.swal(
                'Success!',
                'The agent is no longer managing the credit hire organisation',
                'success'
              );
              this.getAllCreditHireOrganisations();
            })
            .catch(err => {
              window.toastify.error(
                'Error',
                'Sorry, there was an issue updating.'
              );
            })
            .catch(() => {});
        });
    },

    getAllCreditHireOrganisations() {
      window.Ajax.get(
        `/agents/${this.$route.params.identifier}/credit-hire-organisations`
      )
        .then(response => {
          this.credit_hire_organisations = response.data;
        })
        .catch(error => {});

      window.Ajax.get(
        `/agents/${this.$route.params.identifier}/available-credit-hire-organisations`
      )
        .then(response => {
          this.available_credit_hire_organisations = response.data;
        })
        .catch(error => {});
    },

    addCreditHireOrganisation() {
      this.add
        .post(
          `/agents/${this.$route.params.identifier}/credit-hire-organisations`
        )
        .then(response => {
          this.closeAddModal();
          this.getAllCreditHireOrganisations();
          window.toastify.success(
            'Success!',
            'The agent has been given access to manage this credit hire organisation'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an issue assigning agent to the credit hire organisation'
          );
        });
    },

    updateCreditHireOrganisation() {
      this.edit
        .put(
          `/agents/${this.$route.params.identifier}/credit-hire-organisations/${this.edit.credit_hire_organisation}`
        )
        .then(response => {
          this.closeEditModal();
          this.getAllCreditHireOrganisations();
          window.toastify.success(
            'The details were updated successfully',
            'Success!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an issue assigning agent to the credit hire organisation'
          );
        });
    },

    openAddModal() {
      this.modals.add = true;
    },

    closeAddModal() {
      this.modals.add = false;
      this.add.reset();
    },

    closeEditModal() {
      this.modals.edit = false;
      this.edit.reset();
      this.editingIndex = null;
    },

    openEditModal(key) {
      this.modals.edit = true;
      this.editingIndex = key;
      this.edit.modules = this.credit_hire_organisations[key].modules;
      this.edit.credit_hire_organisation = this.credit_hire_organisations[
        key
      ].identifier;
    }
  }
};
</script>
